// extracted by mini-css-extract-plugin
export default {"courseHeader":"styles__courseHeader___HHmfk","contentWrapper":"styles__contentWrapper___vv7nO","thumbnail":"styles__thumbnail___EtiJB"};